import { Ref, RefObject, useRef } from 'react';

/* useForwardRef
  This hook is used to handle forwarding refs in functional components.
  It ensures that if a ref is passed to a component, it can be used to access
  the underlying DOM element or component instance. If no ref is provided,
  it creates a local ref to be used within the component instead.

  This ensures that a ref is always available for use, whether it's passed in or created locally.
*/

const useForwardRef = <T>(ref: Ref<T>): RefObject<T> => {
  const localRef = useRef<T>(null);
  let usableRef: RefObject<T>;

  if (ref && typeof ref === 'object' && ref !== null && 'current' in ref) {
    usableRef = ref as unknown as RefObject<T>;
  } else {
    usableRef = localRef;
  }

  return usableRef;
};

export default useForwardRef;
